import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const sessionId = match[1];

    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id: sessionId });
        setUser(r.data.user);
        window.history.replaceState({}, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch (e) {
        setError(e?.response?.data?.detail || "Authentication failed");
        setTimeout(() => navigate("/?error=auth_failed", { replace: true }), 1500);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F6F1]">
      <div className="flex flex-col items-center gap-4" data-testid="auth-callback">
        <div className="w-10 h-10 border-2 border-[#E4DFD2] border-t-[#B89B5E] rounded-full animate-spin" />
        <div className="text-sm text-[#69747C]">
          {error ? <span className="text-[#7E332D]">{error}</span> : "Signing you in..."}
        </div>
      </div>
    </div>
  );
};

export default AuthCallback;
